import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from 'react-redux'
import {NavLink, useLocation} from "react-router-dom";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {tableTheme} from "../../components/customTable/TableTheme";
import ActionsOptions from "../../components/customTable/ActionsOptions";
import ActionsWrapper from "../../components/customTable/ActionsWrapper";
import EditButton from "../../components/customTable/EditButton";
import DeleteButton from "../../components/customTable/DeleteButton";
import NavigateButton from "../../components/customTable/NavigateButton";
import SearchButton from "../../components/customTable/SearchButton";
import FilterButton from "../../components/customTable/FilterButton";
import {StaticTableOptions} from "../../components/customTable/StaticTableOptions";
import AddButton from "../../components/customTable/AddButton";
import {addCityData, deleteCityData, fetchCityData, updateCityData} from "../../store/city/cityActions";
import MUIDataTable from "mui-datatables";
import DeleteDialog from "../../components/dialogs/DeleteDialog";
import AddDialog from "../../components/dialogs/AddDialog";
import DialogHeader from "../../components/dialogs/DialogHeader";
import TextInput from "../../components/textInput/TextInput";

function Cities({ getMuiTheme = () => createTheme(tableTheme) }) {

    const dispatch = useDispatch()
    const language = useSelector(state => state.userInfos.language)
    const cities = useSelector(state => state.cities.cities)
    const isCity = useSelector(state=>state.cities.isCity)
    const TableOptions = useSelector(state => state.tableOptions.options)
    const [openAdd, setOpenAdd] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [cityId, setCityId] = useState(false)

    const cancelAddRef = useRef(null)
    const cancelDeleteRef = useRef(null)

    const [city, setCity] = useState({})

    const location = useLocation()
    const  { pathname } = location
    const url = pathname.split("/")
    const regionId = url[3]

    const cols = [
        {
            name: "name",
            label: language.city_name,
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <NavLink to={`/admin/regions/${regionId}/cities/${cities[tableMeta.rowIndex].id}/ministries`}>{value}</NavLink>
                    );
                }
            }
        },
        {
            name: "",
            options: {
                ...ActionsOptions,
                customBodyRender: (value, tableMeta, rowIndex) => {
                    return (
                        <ActionsWrapper>
                            <EditButton
                                onClick={() => {
                                    setCityId(cities[tableMeta.rowIndex].id)
                                    setOpenEdit(true)
                                    setOpenAdd(true)
                                    setCity(cities[tableMeta.rowIndex])
                                }}
                            />
                            <DeleteButton
                                onClick={() => {
                                    setCityId(cities[tableMeta.rowIndex].id)
                                    setOpenDelete(true)
                                }
                                }
                            />
                            <NavigateButton navigate={`/admin/regions/${regionId}/cities/${cities[tableMeta.rowIndex].id}/ministries`} />
                        </ActionsWrapper>
                    );
                }
            }
        }];

    const components = {
        icons: {
            SearchIcon: SearchButton,
            ViewColumnIcon: FilterButton,
        }
    }

    const options = {
        ...TableOptions, ...StaticTableOptions,
        selectableRows: "multiple",
        customToolbar: () => {
            return (
                <AddButton onClick={() => {
                    setOpenAdd(true)
                    setOpenEdit(false)
                }} />
            )
        }
    }

    const saveCity = () => {
        dispatch(addCityData(regionId,city.name))
        setOpenAdd(false)
    }

    const deleteCity = () => {
        dispatch(deleteCityData(cityId))
        setOpenDelete(false)
    }

    const editCity = () => {
        dispatch(updateCityData(cityId, city.name))
        setOpenEdit(false)
        setOpenAdd(false)
    }

    useEffect(() => {
        dispatch(fetchCityData(regionId))
    }, [dispatch,isCity])

    return (
        <div>
            <div className="container mt-3 px-3 mx-auto max-w-screen-lg data-table">
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        className="w-full z-0"
                        title={language.cities}
                        data={cities}
                        columns={cols}
                        options={options}
                        components={components}
                    />
                </MuiThemeProvider>
            </div>
            <DeleteDialog
                openDelete={openDelete}
                cancelDeleteRef={cancelDeleteRef}
                setOpenDelete={setOpenDelete}
                deleteItem={deleteCity}
                title={language.delete_city}
                warning={language.city_delete_warning}
            />
            <AddDialog
                isEdit={openEdit}
                openAdd={openAdd}
                setOpenEdit={setOpenEdit}
                setOpenAdd={setOpenAdd}
                cancelAddRef={cancelAddRef}
                saveItem={saveCity}
                editItem={editCity}
            >
                <DialogHeader
                    closeModal={() => setOpenAdd(false)}
                    title={openEdit ? language.edit_city : language.add_city}
                />
                <TextInput
                    label={language.city_name}
                    value={openEdit ? city.name : null}
                    onChange={(e) => setCity({ ...city, name: e.target.value })}
                    placeholder={language.city_name}
                />
            </AddDialog>
        </div>
    );
}

export default Cities;